//let isProd = process.env.NODE_ENV === 'production';

export const frontdoorRoot = `https://frontdoor.gandpconstruction.com`;
export const cdnRoot = `https://cdn.gandpconstruction.com`;
export const frontdoor = `${frontdoorRoot}/sites/gnp-companies`;
export const cdn = `${cdnRoot}`;

export const STATE = {};